import { tryAxios } from '@/api/common/auth'
import { urlPrefix, PostValidate } from '@/configs/api'

const apiUrl = `${urlPrefix}/Users`
//#region 用户相关查询
const GetUserList = `${apiUrl}`
const Post = `${apiUrl}`
const GetTodoMsg = `${apiUrl}/TodoMsg`
const GetMyProfile = `${apiUrl}/MyProfile`
const GetUserAuth = `${apiUrl}/GetUserAuth`
const DeleteUser = (id: number) => `${apiUrl}/${id}`
const InactiveUser = (id: number) => `${apiUrl}/inactive/${id}`
const ActiveUser = (id: number) => `${apiUrl}/active/${id}`
const ApproveUser = (id: number) => `${apiUrl}/approve/${id}`
const Get = (id: number) => `${apiUrl}/${id}`
const GetNewRspblty = `${apiUrl}/newRspblty`
const Put = (id: number) => `${apiUrl}/${id}`
const CheckPwd = `${apiUrl}/checkpwd`
const UpdatePwd = `${apiUrl}/updatepwd`
const ResetPwd = (id: number) => `${apiUrl}/resetpwd/${id}`
const GetUserMenus = `${apiUrl}/GetMenu`
const GetUnitsByUser = `${apiUrl}/GetUnitsByUser`
//#endregion

export const emptyRspbltyUnits: RspbltyUnitData[] = []
const emptySysAuth: ExtendAuthData = {
    HasProvinceUser: true,
    ProvinceCode: '',
    ProvinceName: '',
    UsedBy: 'Province',
    AutoAudit: false,
    ManualRunTask: false,
    ReadOnly: false,
    EventResponse: false,
    UnitGis: false,
    DeleteCruise: false,
    CloseChildPlan: false
}
export const emptyRspblty: RspbltyData = {
    Id: 0,
    UserId: 0,
    CruiseTeamId: 0,
    ResponsibilityId: 0,
    Department: '',
    Position: '',
    BirthDate: new Date(),
    SuperiorName: '',
    ContactorPhone: '',
    SelfIntroduce: '',
    Comments: '',

    CruiseTeamName: '',
    ResponsibilityName: '',
    DepartmentName: '',
    PositionName: '',
    UnitList: emptyRspbltyUnits,
    TeamList: []
}
export const emptyExpert: ExpertData = {
    Id: 0,
    UserId: 0,
    ExpertType: '',
    IdentityCode: '',
    BirthDate: new Date(),
    Education: 0,
    PositionalTitleId: 0,
    ProvinceId: 0,
    CityId: 0,
    SelfIntroduce: '',
    PaymentInfo: '',

    ExpertTypeName: '',
    EducationName: '',
    PositionalName: '',
    ProvinceName: '',
    CityName: '',
    ProfessionList: [],
    ProfessionNames: ''
}
export const emptyUser: UserData = {
    DoTransfer: false,
    TransferUserId: 0,

    Id: 0,
    UserType: 0,
    SubType: 0,
    ApplyUnitId: 0,
    IsProvinceUnit: false,
    UserName: '',
    DisplayName: '',
    Email: '',
    Password: '',
    ConfirmPassword: '',
    SuperiorUnitName: '',
    Contacter: '',
    CellPhone: '',
    Telephone: '',
    Phone: '',
    Address: '',
    Comments: '',
    Inactive: false,
    Approved: false,
    ApprovedBy: 0,
    ApprovedDate: new Date(),
    WeChatNumber: '',
    // 扩展信息
    RoleId: 0,
    RoleName: '',
    UserTypeName: '',
    SubTypeName: '',
    ApplyUnitName: '',
    ProvinceId: 0,
    ProvinceName: '',
    CityId: 0,
    CityCode: '',
    CityName: '',
    CountyId: 0,
    CountyCode: '',
    CountyName: '',
    TownshipId: 0,
    TownshipCode: '',
    TownshipName: '',

    RspbltyInfo: Object.assign({}, emptyRspblty),
    ExportInfo: Object.assign({}, emptyExpert),
    SysAuth: Object.assign({}, emptySysAuth),
    UnitList: []
}
export const emptyUserUnit: UserUnitData = {
    Id: 0,
    UserId: 0,
    UnitId: 0,
    NewUserId: 0,
    NewDate: new Date(),
    UnitCode: '',
    UnitName: ''
}
export interface UserData {
    [key: string]: any

    /** 是否转岗操作 */
    DoTransfer: boolean
    /** 需要转岗的用户id */
    TransferUserId: number

    Id: number
    UserType: number
    SubType: number
    ApplyUnitId: number
    IsProvinceUnit: boolean
    UserName: string
    DisplayName: string
    Email: string
    Password: string
    ConfirmPassword: string
    CellPhone: string
    Telephone: string
    Comments: string
    Inactive: boolean
    ApprovedBy: number
    ApprovedDate: Date
    WeChatNumber: string
    // 扩展信息
    RoleId: number
    RoleName: string
    UserTypeName: string
    SubTypeName: string
    ApplyUnitName: string
    ProvinceId: number
    ProvinceName: string
    CityId: number
    CityCode: string
    CityName: string
    CountyId: number
    CountyCode: string
    CountyName: string
    TownshipId: number
    TownshipCode: string
    TownshipName: string
    RspbltyInfo: RspbltyData
    ExportInfo: ExpertData
    SysAuth: ExtendAuthData
    UnitList: UserUnitData[]
}
export interface UserUnitData {
    Id: number
    UserId: number
    UnitId: number
    NewUserId: number
    NewDate: Date
    UnitCode: string
    UnitName: string
}
export interface RspbltyData {
    Id: number
    UserId: number
    CruiseTeamId: number
    ResponsibilityId: number
    Department: string
    Position: string
    BirthDate: Date
    SuperiorName: string
    ContactorPhone: string
    SelfIntroduce: string
    Comments: string

    CruiseTeamName: string
    ResponsibilityName: string
    DepartmentName: string
    PositionName: string
    TeamList: UserTeamData[]
    UnitList: RspbltyUnitData[]
}
export interface UserTeamData {
    Id: number
    UserId: number
    TeamId: number
    TeamName: string
}
export interface RspbltyUnitData {
    ListId: number
    UnitId: number
    UnitCode: string
    UnitName: string
    CityId: number
    CityName: string
    CountyId: number
    CountyName: string
    ClassId: number
    ClassName: string
    LevelId: number
    LevelName: string
    BatchId: number
    BatchName: string
    PlanId: number
    PlanName: string
}
export interface ExpertData {
    Id: number
    UserId: number
    ExpertType: string
    IdentityCode: string
    BirthDate: Date
    Education: number
    PositionalTitleId: number
    ProvinceId: number
    CityId: number
    SelfIntroduce: string
    PaymentInfo: string

    ExpertTypeName: string
    EducationName: string
    PositionalName: string
    ProvinceName: string
    CityName: string
    ProfessionList: ExpertProfessionData[]
    ProfessionNames: string
}
export interface ExpertProfessionData {
    Id: number
    ExpertId: number
    ProfessionalTechId: number
    ProfessionalName: string
}
export interface UserPwdData {
    [key: string]: any
    UserId: number
    OldPassword: string
    NewPassword: string
    ConfirmPassword: string
}
type SysUsedBy = 'Province' | 'City' | 'County' | null
//功能权限
export interface ExtendAuthData {
    [key: string]: any
    HasProvinceUser: boolean
    ProvinceCode: string
    ProvinceName: string
    UsedBy: SysUsedBy
    AutoAudit: boolean
    ManualRunTask: boolean
    ReadOnly: boolean
    EventResponse: boolean
    UnitGis: boolean
    DeleteCruise: boolean
    CloseChildPlan: boolean
}
export const getAuth = () => {
    return tryAxios({
        method: 'get',
        url: GetUserAuth
    })
}
export const getMyProfile = () => {
    return tryAxios({
        method: 'get',
        url: GetMyProfile
    })
}
export const getTodoMsg = () => {
    return tryAxios({
        method: 'get',
        url: GetTodoMsg
    })
}
export const getList = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: GetUserList,
        params: param
    })
}
export const inactive = (id: number) => {
    return tryAxios({
        method: 'post',
        url: InactiveUser(id)
    })
}
export const active = (id: number) => {
    return tryAxios({
        method: 'post',
        url: ActiveUser(id)
    })
}
export const approve = (id: number) => {
    return tryAxios({
        method: 'post',
        url: ApproveUser(id)
    })
}
export const postData = (data: UserData) => {
    return tryAxios({
        method: 'post',
        url: Post,
        data
    })
}
export const putData = (id: number, data: UserData) => {
    data['UserId'] = id
    return tryAxios({
        method: 'put',
        url: Put(id),
        data
    })
}
export const validateUserField = (field: string, value: any, id?: number) => {
    return tryAxios({
        method: 'post',
        url: PostValidate,
        data: {
            Resource: 'User',
            Field: field,
            Value: value,
            ResourceID: id
        }
    })
}
export const checkPwd = (userId: number, oldPwd: string) => {
    return tryAxios({
        method: 'post',
        url: CheckPwd,
        data: {
            Key: userId,
            Val: oldPwd
        }
    })
}
export const updatePwd = (userId: number, newPwd: string) => {
    return tryAxios({
        method: 'post',
        url: UpdatePwd,
        data: {
            Key: userId,
            Val: newPwd
        }
    })
}
export const resetPwd = (userId: number) => {
    return tryAxios({
        method: 'post',
        url: ResetPwd(userId)
    })
}
export const getData = (id: number) => {
    return tryAxios({
        method: 'get',
        url: Get(id)
    })
}
export const getNewRspblty = () => {
    return tryAxios({
        method: 'get',
        url: GetNewRspblty
    })
}
export const getMenus = () => {
    return tryAxios({
        method: 'get',
        url: GetUserMenus
    })
}
